import React from 'react';
import { Banner, BannerIcon, Button, IconList, Text } from 'components/core';
import { Inline } from 'components/layout';

type EnvType = 'demo' | 'staging' | 'support';

export type EnvironmentAlertProps = {
  env?: EnvType;
  isUserProxied: boolean;
  exitProxyUrl?: string;
};

const EnvironmentAlert = ({
  env,
  isUserProxied,
  exitProxyUrl,
}: EnvironmentAlertProps) => {
  return (
    <>
      {env === 'demo' && (
        <Banner type="info" aria-label="Demo environment alert">
          <Inline alignX="center" spacing={5}>
            <Text>
              Welcome to the demo review! Data will be reset regularly.
            </Text>
            <Button type="success" to="http://www.covidence.org?ref=demo">
              Visit covidence.org
            </Button>
          </Inline>
        </Banner>
      )}

      {env === 'staging' && (
        <Banner type="warning" aria-label="Staging environment alert">
          <Inline>
            <Text>
              This is the staging site used for testing purposes only.
            </Text>
          </Inline>
        </Banner>
      )}

      {env === 'support' && (
        <Banner type="warning" aria-label="Support environment alert">
          <Inline>
            <Text>
              This is a support app environment. Changes made here will not
              impact production.
            </Text>
          </Inline>
        </Banner>
      )}

      {isUserProxied && (
        <Banner type="danger" aria-label="User proxied alert">
          <Inline alignX="center" spacing={5}>
            <Inline>
              <BannerIcon icon={IconList.solid.faTriangleExclamation} />
              <Text>Caution, you are currently proxied.</Text>
            </Inline>
            <Button type="danger" variant="outline" to={exitProxyUrl}>
              Exit
            </Button>
          </Inline>
        </Banner>
      )}
    </>
  );
};

export { EnvironmentAlert };
